import gql from 'graphql-tag';

export const GET_ALL_SERVERS = gql`
  {
    serverList {
      id
      hostname
      status
      type
      available
      usage {
        cpu
        ram
        hdd
      }
      batch {
        name
        color
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/server/all.js